<template>
  <div id="Resource_apply">
    <div class="font">
      <span class="introSubTitle"><b>遥感自然资源地理要素更新系统</b></span>
      <p class="textStyle">
        针对自然资源部对山、水、园、林、草等典型要素更新更精确、更快速、更综合的应用需求，研制了遥感典型要素智能提取与更新系统。在鄂州市全域范围内，取得了高精度、可靠的道路要素检测结果，水体要素检测结果，建筑物要素检测结果，耕地要素检测结果。
      </p>

      <img
          width="100%"
          src="@/assets/img/scientific/Resource_apply-1.png"
      />
<!--      <el-row :gutter="10">-->
<!--        <el-col :span="12">-->
<!--        </el-col>-->
<!--        <el-col :span="12">-->
<!--          <img-->
<!--              width="100%"-->
<!--              src="@/assets/img/scientific/Resource_apply-1.jpg"-->
<!--          />-->
<!--        </el-col>-->
<!--      </el-row>-->
    </div>
  </div>
</template>

<script>
// import myVideo from "../../node_modules/vue-video";

export default {
  data() {
    return {};
  },
};
</script>

<style lang="less">
#Resource_apply {
  margin-top: 20px;
  .img_figure{
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #454545;
  }
  // .font {
  //   // font-family: "Times New Roman", Times, serif;
  // }
}
</style>
